import React from 'react';
import { cn } from '@/lib/utils';

type VessLogoVariant = 'iridescent' | 'default' | 'muted';
type VessLogoSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

interface VessLogoProps {
  variant?: VessLogoVariant;
  size?: VessLogoSize;
  label?: string;
  className?: string;
}

const sizeStyles: Record<VessLogoSize, React.CSSProperties> = {
  xs: { fontSize: '10px', lineHeight: 1 },
  sm: { fontSize: '14px', lineHeight: 1 },
  md: { fontSize: '20px', lineHeight: 1 },
  lg: { fontSize: '84px', lineHeight: 1 },
  xl: { fontSize: '168px', lineHeight: 1 },
};

const variantClasses: Record<VessLogoVariant, string> = {
  iridescent: 'vess-iridescent-text',
  default: 'text-foreground',
  muted: 'text-muted-foreground',
};

export const VessLogo: React.FC<VessLogoProps> = ({
  variant = 'default',
  size = 'lg',
  label = 'vess.',
  className,
}) => {
  return (
    <span
      style={sizeStyles[size]}
      className={cn(
        'font-display font-bold tracking-tight lowercase',
        variantClasses[variant],
        className,
      )}
    >
      {label}
    </span>
  );
};
